import ReactGAImport from 'react-ga4';
// Dev pre-bundling can wrap the CJS export one level deeper; unwrap it.
const ReactGA: any = (ReactGAImport as any)?.default ?? ReactGAImport;

const MEASUREMENT_ID = 'G-HNPWJML3E8';

export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
};

export const logPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

export const logEvent = (category: string, action: string, label?: string, value?: number) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};

// Custom event tracking functions
export const trackEventRegistration = (eventId: string, eventName: string, userId: string) => {
  logEvent('Event', 'Register', `${eventName} (${eventId})`, 1);
};

export const trackAthleteImport = (count: number, importId: string) => {
  logEvent('Import', 'Athletes', `Count: ${count}`, count);
};

export const trackQRDownload = (userId: string, profileType: string) => {
  logEvent('Download', 'QR_Code', profileType, 1);
};

export const trackProfileView = (profileId: string, viewerRole: string) => {
  logEvent('Profile', 'View', `Viewer: ${viewerRole}`, 1);
};

export const trackCoachInvitation = (eventId: string, coachEmail: string) => {
  logEvent('Coach', 'Invite', `Event: ${eventId}`, 1);
};

export const trackMembershipPurchase = (membershipSlug: string, price: number) => {
  logEvent('Membership', 'Purchase', membershipSlug, price);
};

export const trackFormSubmission = (formName: string, success: boolean) => {
  logEvent('Form', success ? 'Submit_Success' : 'Submit_Failure', formName, success ? 1 : 0);
};

export const trackSearch = (searchType: string, query: string, resultCount: number) => {
  logEvent('Search', searchType, query, resultCount);
};

export const trackEmailSent = (emailType: string, recipientCount: number) => {
  logEvent('Email', 'Send', emailType, recipientCount);
};

export const trackFileUpload = (fileType: string, fileSize: number) => {
  logEvent('Upload', fileType, `Size: ${Math.round(fileSize / 1024)}KB`, 1);
};
